import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import BucketFilled from '../../Assetes/Images/kfc-basket.png';
import Button from '@mui/material/Button';
import Modal from 'react-bootstrap/Modal';
import OrderHistoryDetail from './OrderHistoryDetail';
import ReOrderCard from './ReOrderCard';
import { connect, useSelector } from 'react-redux';
import Api from '../../Components/Api';
import { ordersList } from '../../Redux/actions/menu';
import Header from '../../Components/Header';
import { saveCart } from '../../Redux';
import GoBack from '../BackButton/GoBack';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import Footer from '../../Components/Footer';


function OrderHistory(props: any) {
    const ordersList = useSelector((state: any) => state.menu.orderList);
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const history=useHistory();
    const lang = useCurrentLocale();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!isLogged) {
            toast.error(t("PLEASE_LOGIN"))
            history.push(`/${lang}/menu`);
        } else {
            props.ordersList()
        }
    }, []);
    const { t } = useTranslation();

    return (
        <><Header />
            <div className='container order-history profile-title mt-120'>
                <div className='d-flex align-items-center gap-10 mb-3 web-backbtn'>
                    <GoBack/>
                <h2 className='mb-0'>{t("ORDER_HISTORY")}</h2>
                </div>
                { ordersList.length>0?
                    <div className="row">
                    
                        {ordersList.map((order: any, id: any) =>
                            <div className="col-md-3 col-6" key={id}>
                                <ReOrderCard order={ order} saveCart={props.saveCart}/>
                            </div>
                        )}
                     
                </div> 
                 
                :<div >
                    <h2 className='note-found-data'>{t("NO_ORDER_FOUND")}</h2>
                    <button className='kfc-basket-history' onClick={()=>history.push(`/${lang}/menu`)}>{t("EXPLOREMENU")}</button>
                </div>
                }
                

            </div>
            <Footer />
        </>
    )
} 

const mapDispatchToProps = (dispatch: any) => {
    return {
        ordersList: function () {
            dispatch(ordersList());
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        }

    }
}
export default connect(null, mapDispatchToProps)(OrderHistory);
